<template>
  <div
    class="news-cont-box"
    ref="box"
  >
  <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-shadow: 0px 2px 3px 0px rgba(218, 218, 218, 0.25);
        padding: 7px 16px;
        position: fixed;
        width: 100%;
        left: 0;
        top: 0;
        background: #fff;
        box-sizing: border-box;
      "
    >
      <img
        style="width: 132px; height: 35px"
        src="@/assets/kfimage/backHomeLogo.png"
        alt=""
      />
      <div
        style="padding: 0px 0 0 16px; display: flex; align-items: center"
        @click="handleClickForHome"
      >
        <img
          style="width: 40px; height: 28px"
          src="@/assets/kfimage/backHomeIcon.png"
          alt=""
        />
      </div>
    </div>
    <p class="title" style="margin-top:50px">{{ title }}</p>
    <ul class="time">
      <li v-if="source">{{ source }}</li>
      <li>{{ createTime }}</li>
    </ul>
    <div class="swipe-box">
      <van-swipe
        ref="swipe"
        :autoplay="autoplayData"
        :loop="true"
        :touchable="true"
        :show-indicators="false"
       >
        <van-swipe-item  
          v-for="(image, index) in info"
          :key="index">
          <el-image class="swipe-img" draggable="false" :src="image.lowUrl || image.url" fit="cover">
            <div slot="error" class="image-slot">
              <img :src="require('@/assets/img/default.png')">
            </div>
          </el-image>
<!-- 
          <img
            class="swipe-img" draggable="false"
            :src="image.lowUrl || image.url"
          /> -->
          <span class="pic-index">
            <i style="color:#EF983C;font-style:normal">{{ index + 1 }}</i>/{{ info.length }}
          </span>
        </van-swipe-item>
      </van-swipe>
      <span
        class="swipe-box-left-btn"
        @click="swipeLeft">
        <van-icon name="arrow-left" />
      </span>
      <span
        class="swipe-box-right-btn"
        @click="swipeRight">
        <van-icon name="arrow" />
      </span>
    </div>
    <van-swipe class="describe-box"
      ref="describeSwipe"
      :touchable="true"
      :autoplay="autoplayData"
      :loop="true"
      :show-indicators="false" >
      <van-swipe-item v-for="(image, index) in info" :key="index" >
        <p class="describe-txt">
          {{ image.describe || "" }}
        </p>
      </van-swipe-item>
    </van-swipe>
    <ul style="color:#666;line-height:28px;font-size: 14px;margin:6px 0;">
        <li v-if="cont.editor"><i style="margin-right:5px">|</i>编辑: {{cont.editor}}</li>
        <li v-if="cont.author"><i style="margin-right:5px">|</i>责任编辑: {{cont.author}}</li>
      </ul>
     <div
        v-if="wmkUse!=='0'"
        style="text-align:left;margin-bottom:16px;color: #999;font-size: 12px;"
        :style="{fontSize:waterMark.wmkWordSize+'px',opacity:(waterMark.wmkWordTrans/100)}">
        {{waterMark.wmkWordContent}}
      </div>
  </div>
</template>

<script>
import * as sctipts from "../service/share";
import share from "../utils/share";
export default {
  data () {
    return {
      pageType:1,
      cont:'',
      title: "",
      author: "",
      createUser:"",
      source: "",
      createTime: "",
      info: "",
      webcommentList: [],
      type: "0",
      versionUrl: "",
      appName: "",
      appIcon: '',
      anyangIcon: require('../assets/img/logo.png'),
      shareIcon: require('../assets/img/shareLogo.png'),
      editor: "",
      linkList: [],
      newList: [],
      appScheme: "",
      viewTotal: "",
      picIndex: 0,
      // 水印
      waterMark: {},
      // 是否开启水印 wmkUse 0 否 1 是
      wmkUse: 0,
      wmkOptions:[],
      autoplayData:3000,
    };
  },
  mounted () {
    if (this.equipmentType() == "iOS") {
      this.type = 0;
    } else if (this.equipmentType() == "Android") {
      this.type = 1;
    } else {
      this.type = 3;
    }
    if (this.$route.query.id) {
      sctipts
        .getCont({
            id:this.$route.query.id,
            type:this.$route.query.type
    })
        .then(({ data }) => {
          if (data.status == 0) {
            if (data.data) {
              this.cont = data.data
              this.title = data.data.title || "";
              this.source = data.data.source || "";
              this.author = data.data.author || "";
              this.editor = data.data.editor || "";
              this.createUser = data.data.createUser || "";
              this.createTime = sctipts.initTime(data.data.createTime, 2);
              this.info = data.data.info || "";
              this.viewTotal = data.data.viewTotal;
              document.title = this.title;
              this.linkList = data.data.linkList?data.data.linkList.slice(0,3):[];
              this.newList = data.data.newList;
              this.wmkUse = data.data.wmsUse;
              let obj={
                title: data.data.title,
                desc: data.data.news,
                link: location.href,
                img: this.appIcon,
              }
              let url = process.env.NODE_ENV === 'production' ? window.location.href : process.env.VUE_APP_URL+this.$route.fullPath;
              share.getJSSDK(url.split('#')[0],obj)
              if (this.wmkUse == 1) {
                // 获取文章水印列表
                  let obj = {
                    pageIndex: 1,
                    pageSize: 99999,
                    wmkRange: 1,
                  };
                  sctipts.getWater(obj).then((res) => {
                    if (res.data.status === 0 && res.data.data.list) {
                      var waterData = res.data.data.list.filter((val) => {
                        return val.wmkId == data.data.wmkId
                      })
                      this.waterMark = waterData[0]
                    };
                  })
              }
            }
          } else {
            console.log(data.desc);
          }
        })
        .catch((res) => {
          console.log("连接服务器错误");
        });
    } else {
      console.log("未获取id");
    }
  },
  methods: {
    handleClickForHome() {
      var oA = document.createElement("a"); //创建a标签
      oA.href = "https://www.kftv.net.cn";
      oA.target = "_self"; //添加 target 属性
      oA.click(); //模拟点击
    },
    equipmentType () {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return "Android";
      } else if (isiOS) {
        return "iOS";
      } else {
        return "noMobileDevices";
      }
    },
    initTime (time, type) {
      return sctipts.initTime(time, type);
    },
    getDateDiff (time) {
      return sctipts.getDateDiff(time);
    },
    imgPath (event) {
      if (event.target.nodeName == "IMG") {
        // 获取触发事件对象的属性
        let allPathArr = [];
        let index = "";
        for (
          let i = 0;
          i < this.$refs.Introduction.querySelectorAll("img").length;
          i++
        ) {
          allPathArr.push(
            this.$refs.Introduction.querySelectorAll("img")[i].src
          );
        }
        allPathArr.forEach((val, ind) => {
          if (val == event.target.src) {
            index = ind;
          }
        });

        let objData = {
          thisPath: event.target.src,
          allPath: allPathArr,
          indexOf: index,
        };
        if (this.equipmentType() == "iOS") {
          window.webkit.messageHandlers.showImage.postMessage(objData);
        } else if (this.equipmentType() == "Android") {
          Android.openImage(event.target.src, allPathArr, index);
        }
      }
    },
    // downApp() {
    //   let u = navigator.userAgent;
    //   let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    //   let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //   if (isAndroid) {
    //     let ua = navigator.userAgent.toLowerCase();
    //     let isWeixin = ua.indexOf("micromessenger") != -1;
    //     if (isWeixin) {
    //       alert("请点击右上方选择浏览器打开本页面下载app");
    //     } else {
    //       window.location.href = this.versionUrl;
    //     }
    //   } else if (isiOS) {
    //     window.location.href = this.versionUrl;
    //   } else {
    //     alert("请使用手机打开本页面。");
    //   }
    // },
    openApp (item) {
      let path = this.$route.push
      this.$router.push({path,query:{id:item.releaseSourceId,bundleID:this.$route.query.bundleID}})
    },
    downApp (item) {
      // 1文章,2 视频, 3  电视直播, 4 活动直播, 5 栏目详情, 6 图片详情, 7 爆料详情
      var link=''
        if (item.releaseSourceId) {
          link = `${this.appScheme}://${this.$getModules(6)}?sourceId=${item.releaseSourceId}`;
        }else{
          link = `${this.appScheme}://${this.$getModules(6)}?sourceId=${this.$route.query.id}`;
        }
      var downUrl = location.origin+'/invitation?type='+this.$route.query.type+'&bundleID='+this.$route.query.bundleID;
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面");
        } else {
          var loadDateTime = new Date();
          window.setTimeout(function() {
              var timeOutDateTime = new Date();
              if (timeOutDateTime - loadDateTime < 5000) {
                //下载分享页
                window.location = downUrl;
              } else {
                window.close();
              }
          },500);
          window.location = link;
        }
      } else if (navigator.userAgent.match(/android/i)) {
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面");
        } else {
          window.location.href = link;
          window.setTimeout(() => {
            //下载分享页
            window.location = downUrl
          }, 2500);
        }
      }
    },
    returnImgPath (row) {
      if (row.coverimgStyleId == 0) {
        return require("@/assets/img/default.png");
      } else {
        if (row.coverimgLowPathList) {
          if (row.coverimgLowPathList[0]) {
            return row.coverimgLowPathList[0];
          } else if (row.coverimgPathList) {
            if (row.coverimgPathList[0]) {
              return row.coverimgPathList[0];
            }
          }
        } else if (row.coverimgPathList) {
          if (row.coverimgPathList[0]) {
            return row.coverimgPathList[0];
          }
        } else {
          return "";
        }
      }
    },
    // swipeChange (ind) {
    //   this.picIndex = ind;
    // },
    on_bot_enter() {
      this.autoplayData = 0
    },
    on_bot_leave() {
      this.autoplayData = 3000
    },
    swipeLeft () {
      this.$refs.swipe.prev();
      this.$refs.describeSwipe.prev();
      this.autoplayData = 0
      setTimeout(() => {
        this.autoplayData = 3000
      }, 2000);
    },
    swipeRight () {
      this.$refs.swipe.next();
      this.$refs.describeSwipe.next();
      this.autoplayData = 0
      setTimeout(() => {
        this.autoplayData = 3000
      }, 2000);
    },
  },
};
</script>

<style scoped>
.audio-view-box{
  margin-top: 0px;
}
.news-cont-box {
  padding: 0 16px;
  box-sizing: border-box;
  overflow: hidden;
}
.title {
  max-height: 50px;
  font-weight: bold;
  margin-top: 20px;
  color: #333;
  font-weight: 700;
  font-size: 18PX;
  font-family: SourceHan;
  line-height: 1.3;
  letter-spacing: 0;
  text-align: left;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.time {
  display: flex;
  font-size: 12px;
  align-items: center;
}

.time > li {
  margin-right: 10px;
  color: #999;
  font-size: 12PX;
  line-height: 1.5;
  font-family: SourceHan;
}
.swipe-img {
  display: block;
  width: 375px;
  height: 260px;
  object-fit: cover;
  background-color: #f5f5f5;
}
.Introduction{
  margin-bottom: 16px;
  margin-top: 22px;
  overflow-y: auto;
  font-size: 18px;
}
.Introduction-hidden {
  height: 300px;
  overflow: hidden;
  position: relative;
}
.Introduction-hidden-icon {
  content: "";
  width: 100%;
  height: 200px;
  background-image: linear-gradient(transparent, #fff);
  z-index: 9999;
  margin-top: -200px;
  position: relative;
}
.Introduction-hidden-icon img {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: auto;
}
.open-app {
  width: 100%;
  display: block;
  border: none;
  height: 44px;
  background-color: #be1928;
  color: #fff;
  font-size: 14px;
  border-radius: 30px;
  margin-bottom: 22px;
  outline: none;
  text-align: center;
  line-height: 44px;
  text-decoration: none;
}
.open-app-border {
  width: 100%;
  display: block;
  border: none;
  height: 44px;
  border: 1px solid #fa3e3d;
  color: #fa3e3d !important;
  font-size: 14px;
  border-radius: 5px;
  margin-bottom: 22px;
  outline: none;
  text-align: center;
  line-height: 44px;
  text-decoration: none;
}
.all-com-title {
  font-size: 16px;
  color: #333;
  font-weight: bold;
  margin-bottom: 0px;
}
.news-links {
  overflow: hidden;
  margin-top: 25px;
  /* margin-bottom: 60px; */
}
.news-links > li {
  height: 86px;
  margin-bottom: 23px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.news-links > li > div {
  width: calc(100% - 140px);
  height: 86px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.news-links > li > div > p {
  font-size: 16px;
  color: #333;
  height: 45px;
  overflow: hidden;
  line-height: 22px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-bottom: 5px;
}
.news-links > li > div > span {
  font-size: 12px;
  color: #8a8a8a;
  height: 20px;
  line-height: 20px;
  margin-top: 15px;
}
.news-links > li > .el-image {
  width: 125px;
  height: 85px;
  border-radius: 3px;
  margin-right: 12px;
  border: none;
}
.news-links > li > .el-image >>> .image-slot{
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 85px;
  color: #dedede;
}
.news-links > li > .el-image >>> .image-slot img{
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
.swipe-img >>> .image-slot{
  width: 100%;
  height: 100%;
}
.swipe-img >>> .image-slot img{
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.news-newList-item-left > .el-image {
  border-radius: 3px;
  object-fit: cover;
}
.describe-txt {
  font-size: 14px;
  font-family: SourceHan;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  margin-top: 12px;
  margin-bottom: 15px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.swipe-box {
  width: 375px;
  height: 260px;
  position: relative;
  margin-top: 15px;
  margin-left: -15px;
}
.swipe-box-left-btn,
.swipe-box-right-btn {
  width: 22px;
  height: 22px;
  background-color: rgba(0, 0, 0, 0.3);
  text-align: center;
  color: #fff;
  line-height: 25px;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
  font-size: 16px;
}
.swipe-box-left-btn {
  left: 10px;
}
.swipe-box-right-btn {
  right: 10px;
}
</style>
<style scoped>
.van-swipe-item .pic-index{
  position: absolute;
  right: 15px;
  bottom: 15px;
  font-size: 16px;
  display: block;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 4px 8px;
  color: #fff;
  border-radius: 3px;
}
/* .describe-box >>> .van-swipe__indicators{
  display: none;
}
.swipe-box >>> .van-swipe__indicators{
  display: none;
} */
</style>
